import { render, staticRenderFns } from "./TravelNotesIndex.vue?vue&type=template&id=32720a4c&scoped=true"
import script from "./TravelNotesIndex.vue?vue&type=script&lang=js"
export * from "./TravelNotesIndex.vue?vue&type=script&lang=js"
import style0 from "./TravelNotesIndex.vue?vue&type=style&index=0&id=32720a4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32720a4c",
  null
  
)

export default component.exports